export default __webpack_public_path__ + "static/person_3-0cb33d0b7df9d24e0b686418dd3cb0ad.png";